import { render, staticRenderFns } from "./view-my-loan.vue?vue&type=template&id=2be5fbad"
import script from "./view-my-loan.vue?vue&type=script&lang=js"
export * from "./view-my-loan.vue?vue&type=script&lang=js"
import style0 from "./view-my-loan.vue?vue&type=style&index=0&id=2be5fbad&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports